<div class="bottom-sheet-suggest-change">
  <div class="my-modal__close" (click)="closeActiveModal()">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <div class="d-flex flex-column align-items-center p-1 position-relative w-100 review-modal" style="overflow: auto">
      <div class="w-100 d-flex" [class.justify-content-between]="suggestChangeModalCurrentIndex != -1" [class.justify-content-end]="suggestChangeModalCurrentIndex == -1">
        <button class="btn" *ngIf="suggestChangeModalCurrentIndex != -1" (click)="suggestChangeModalCurrentIndex = -1"><i class="fa fa-arrow-left"></i> Back</button>
        <button class="btn btn-sm btn-outline-primary contribute-btn mr-5">
          {{ currentUserPoints }}
          <img src="../../../assets/images/gold-coin.png" />
        </button>
      </div>
      <div class="w-100 d-flex justify-content-end mb-2"></div>
      @if (suggestChangeModalCurrentIndex == -1) {
        <div class="suggest-change">
          <div (click)="suggestChangeModalCurrentIndex = 1; activeSuggestionChangeModalTab = 1"><i class="fa-solid fa-pen"></i> Before / After Survey</div>
          <div (click)="suggestChangeModalCurrentIndex = 4"><i class="fa-solid fa-question"></i> How To Order</div>
          <div (click)="suggestChangeModalCurrentIndex = 2; activeSuggestionChangeModalTab = 2"><i class="fa-solid fa-circle-info"></i> Update Info</div>
          <div (click)="suggestChangeModalCurrentIndex = 3"><i class="fa fa-star"></i> Update Promotion</div>
        </div>
        <div class="text-justify p-2 text-sm" style="color: var(--primary)">Helping your community update locale based products and services help you accumulate points and increases your level within the world of Kachiing</div>
      } @else if (suggestChangeModalCurrentIndex == 4) {
        <div class="d-flex flex-column h-100 w-100 justify-content-center">
          <div class="d-flex w-100 justify-content-center flex-column">
            <span> How Do You Order?</span>
            <!-- <input type="text" placeholder="You order by..." class="form-control" [(ngModel)]="surveyHowOrder" /> -->
            <textarea placeholder="You order by..." class="form-control" [(ngModel)]="surveyHowOrder"></textarea>
          </div>
          <div class="d-flex w-100 justify-content-center flex-column">
            <span> How Much Do You Normally Spend On This?</span>
            <input type="number" placeholder="Amount" class="form-control" [(ngModel)]="surveyHowMuchSpend" />
          </div>

          <div class="d-flex w-100 justify-content-center flex-column">
            <span> Any point of contact (Optional)</span>
            <!-- <textarea [(ngModel)]="surveyHowOrder" placeholder="You order by..." class="form-control" rows="3"></textarea> -->
            <input type="text" placeholder="Point of contact (eg John, Uncle, Short Hair Auntie, Lady Boss)" class="form-control" [(ngModel)]="surveyPointOfContact" />
          </div>
       </div>

      }
      @else if (suggestChangeModalCurrentIndex == 1) {
        <div class="w-100 d-flex justify-content-start mb-4" style="overflow-x: auto">
          <!-- <button (click)="activeSuggestionChangeModalTab = 12" class="btn btn-sm btn-{{ activeSuggestionChangeModalTab == 12 ? 'dark' : 'light' }}">How To?</button> -->

          <button (click)="activeSuggestionChangeModalTab = 1" class="btn btn-sm btn-{{ activeSuggestionChangeModalTab == 1 ? 'dark' : 'light' }}">Survey Before</button>
          <button (click)="activeSuggestionChangeModalTab = 6" class="btn btn-sm btn-{{ activeSuggestionChangeModalTab == 6 ? 'dark' : 'light' }}">Survey After</button>
          <!-- <button (click)="activeSuggestionChangeModalTab = 12"
              class="btn btn-sm btn-{{ activeSuggestionChangeModalTab == 12 ? 'dark' : 'light' }}">How Much?</button> -->
          <!-- <button (click)="activeSuggestionChangeModalTab = 14" class="btn btn-sm btn-{{ activeSuggestionChangeModalTab == 14 ? 'dark' : 'light' }}">Poll</button> -->
          <button class="btn btn-sm btn-{{ activeSuggestionChangeModalTab == 11 ? 'dark' : 'light' }}" (click)="activeSuggestionChangeModalTab = 11" *ngIf="typesOfParentCategory?.length">Types</button>
        </div>
      } @else if (suggestChangeModalCurrentIndex == 2) {
        <div class="w-100 d-flex justify-content-start mb-4" style="overflow-x: auto">
          <button (click)="activeSuggestionChangeModalTab = 2" class="btn btn-sm btn-{{ activeSuggestionChangeModalTab == 2 ? 'dark' : 'light' }}">Price</button>

          <button (click)="activeSuggestionChangeModalTab = 7" class="btn btn-sm btn-{{ activeSuggestionChangeModalTab == 7 ? 'dark' : 'light' }}" *ngIf="doesProductHaveVartianst">How To</button>

          <button (click)="activeSuggestionChangeModalTab = 3" class="btn btn-sm btn-{{ activeSuggestionChangeModalTab == 3 ? 'dark' : 'light' }}">Images</button>
          <button (click)="activeSuggestionChangeModalTab = 4" class="btn btn-sm btn-{{ activeSuggestionChangeModalTab == 4 ? 'dark' : 'light' }}" *ngIf="productData?.ratings?.length">Review Info</button>
          <button (click)="activeSuggestionChangeModalTab = 5; checkReviewDescritpionOverflow()" class="btn btn-sm btn-{{ activeSuggestionChangeModalTab == 5 ? 'dark' : 'light' }}">Description</button>

          <button (click)="activeSuggestionChangeModalTab = 8" class="btn btn-sm btn-{{ activeSuggestionChangeModalTab == 8 ? 'dark' : 'light' }}">Employees</button>
        </div>
      } @else if (suggestChangeModalCurrentIndex == 3) {
        <div *ngTemplateOutlet="addAdsInProduct"></div>
      }
      <div *ngIf="activeSuggestionChangeModalTab == 14 && suggestChangeModalCurrentIndex == 1">
        <div class="d-flex w-100 justify-content-end">
          <button class="t-btn" *ngIf="isAdmin()" (click)="openPollModal()"><i class="fa-solid fa-poll"></i> Create Poll</button>
        </div>
        <div class="d-flex flex-column align-items-center">
          <p class="title-header my-4"><i class="fa-solid fa-poll"></i> Poll</p>
          @if (surveyPoll?.isLoading) {
            <span>Loading...</span>
          } @else if (surveyPoll?.data) {
            <app-poll-card [pollData]="surveyPoll?.data"></app-poll-card>
          } @else {
            <div class="bordered">No Poll Found For This Product</div>
          }
        </div>
      </div>
   
      <div *ngIf="activeSuggestionChangeModalTab == 11 && suggestChangeModalCurrentIndex == 1" class="d-flex flex-column align-items-center">
        <span class="my-3">Select the type you think describes this product</span>
        <div class="w-100 d-flex flex-wrap" style="gap: 1em">
          <button *ngFor="let type of typesOfParentCategory" [class.active]="type.active" class="btn btn-sm btn-outline-secondary" (click)="type.active = !type.active">
            {{ type.name }}
          </button>
        </div>
      </div>

      <ng-container *ngIf="activeSuggestionChangeModalTab == 7 && suggestChangeModalCurrentIndex == 2">
        <p class="title-header my-2">How To</p>
        <textarea class="w-100 form-control" rows="7" [(ngModel)]="howToText" placeholder="List How You Used the product/services and make sure to check the variants you used"></textarea>
        <div class="d-flex flex-column mt-2 w-100">
          <ng-container *ngFor="let variant of productData?.foodSpecs">
            <div *ngIf="variant.value != '0'" class="w-100 d-flex align-items-center">
              <input [id]="'varhowTo' + variant.value" type="checkbox" style="accent-color: var(--secondary)" [checked]="howToVariants.has(variant.value)" (change)="!$event.target.checked ? howToVariants.delete(variant.value) : howToVariants.add(variant.value)" />
              <label class="ml-2" [for]="'varhowTo' + variant.value" style="margin: unset">{{ variant.value }}</label>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="activeSuggestionChangeModalTab == 8 && suggestChangeModalCurrentIndex == 2">
        <div class="w-100">
          <p class="title-header my-2" [class.grayed-out]="reviewPropExists(productData, 'newCompanyEmployees', 'arr')">
            Suggest New Teammate
            <span class="plus-btn" (click)="addNewEmployee()" [class.grayed-out]="reviewPropExists(productData, 'newCompanyEmployees', 'arr')">+</span>
          </p>

          <div class="d-flex flex-column">
            <ng-container *ngFor="let emp of newCompanyEmployees; index as i">
              <!-- @if(emp.encodedPhoto){
                    <img [src]="emp.encodedPhoto"  class="shadow ml-2" style="width: 5em; height: 5em;" (click)="selectImageOfNewEmployee(i)"/>
                  }@else{
                    <img src="../../assets/images/uploadd2.png"  class="shadow ml-2" style="width: 5em; height: 5em;" (click)="selectImageOfNewEmployee(i)"/>
                  }
                  <input type="file" class="d-none" [id]="'sugNewEmp' + i" (change)="setImageOfNewEmployee(i, $event)"/> -->
              <div style="display: grid; grid-template-columns: 11rem 1fr 1.5rem; gap: 0.75em; margin-bottom: 1rem">
                <div class="d-flex justify-content-center">
                  <button class="btn btn-sm btn-outline-primary mr-2" (click)="emp.gender = 'M'" [class.active]="emp.gender == 'M'">
                    <img src="../../assets/images/man-2.png" style="width: 5rem; height: 5rem; object-fit: cover" />
                  </button>
                  <button class="btn btn-sm btn-outline-primary" (click)="emp.gender = 'F'" [class.active]="emp.gender == 'F'">
                    <img src="../../assets/images/woman.png" style="width: 5rem; height: 5rem; object-fit: cover" />
                  </button>
                </div>
                <div>
                  <input [(ngModel)]="emp.name" type="text" class="form-control mb-3" placeholder="Name Of The Teammate" />
                  <input [(ngModel)]="emp.title" class="form-control" type="text" placeholder="Title Of The Teammate" />
                </div>
                <button class="btn btn-sm btn-outline-secondary" style="border: 1px solid #ced4da !important" (click)="removeEmployee(i)"><i class="fa-solid fa-times"></i></button>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="activeSuggestionChangeModalTab == 6 && suggestChangeModalCurrentIndex == 1">
        <p class="title-header my-2">Survey After</p>
        <ng-container *ngFor="let option of suggestions; index as j">
          <ng-container *ngIf="(nonFoodIndexes.includes(j) || productIsFood(productData)) && (showMoreSuggestionInfos || j < 4)">
            <p class="title-header my-2" [class.grayed-out]="reviewPropExists(productData, option.apiName, 'int')">{{ option.title }}</p>
            <div class="d-flex flex-wrap justify-content-center" style="gap: 1em">
              <button (click)="option.value == i + 1 ? (option.value = 0) : (option.value = i + 1)" [class.active]="option.value == i + 1" *ngFor="let altValue of option.options; index as i" class="card-sub-cate">
                <span class="card-sub-cate__title" [class.grayed-out]="reviewPropExists(productData, option.apiName, 'int')">{{ altValue }}</span>
              </button>
            </div>
          </ng-container>

          <button *ngIf="j == 3 && productIsFood(productData)" class="btn btn-secondary my-3" (click)="showMoreSuggestionInfos = !showMoreSuggestionInfos">
            <i [ngClass]="showMoreSuggestionInfos ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
            {{ showMoreSuggestionInfos ? "Hide More Info" : "Show More Info" }}
          </button>
        </ng-container>
        <p class="title-header my-2" [class.grayed-out]="reviewPropExists(productData, 'isSatisfiedAfter', 'int')">Are you satisfied with the service?</p>

        <div class="w-100 d-flex mt-2 justify-content-center" style="gap: 2em">
          <button [class.active]="isSatisfiedAfter == 1" [class.grayed-out]="reviewPropExists(productData, 'isSatisfiedAfter', 'int')" (click)="isSatisfiedAfter == 1 ? (isSatisfiedAfter = 0) : (isSatisfiedAfter = 1)" class="card-sub-cate">
            <span class="card-sub-cate__title">Yes</span>
          </button>

          <button (click)="isSatisfiedAfter == 2 ? (isSatisfiedAfter = 0) : (isSatisfiedAfter = 2)" class="card-sub-cate" [class.grayed-out]="reviewPropExists(productData, 'isSatisfiedAfter', 'int')" [class.active]="isSatisfiedAfter == 2">
            <span class="card-sub-cate__title">No</span>
          </button>
        </div>
        <ng-container *ngIf="productData?.subRegionName?.toLowerCase() == profileInfo2?.regionName?.toLowerCase()">
          <p class="title-header my-2">Would You Recommend This Business To Your Friend?</p>

          <div class="w-100 d-flex mt-2 justify-content-center" style="gap: 2em" [class.grayed-out]="reviewPropExists(productData, 'wouldRecommend', 'int')">
            <button [class.active]="wouldRecommend == 1" [class.grayed-out]="reviewPropExists(productData, 'wouldRecommend', 'int')" (click)="wouldRecommend == 1 ? (wouldRecommend = 0) : (wouldRecommend = 1)" class="card-sub-cate">
              <span class="card-sub-cate__title">Yes</span>
            </button>

            <button (click)="wouldRecommend == 2 ? (wouldRecommend = 0) : (wouldRecommend = 2)" class="card-sub-cate" [class.grayed-out]="reviewPropExists(productData, 'wouldRecommend', 'int')" [class.active]="wouldRecommend == 2">
              <span class="card-sub-cate__title">No</span>
            </button>
          </div>
        </ng-container>
      </ng-container>

      <!-- Tab 1: Questions -->
      <ng-container *ngIf="activeSuggestionChangeModalTab == 1 && suggestChangeModalCurrentIndex == 1">
        <p class="title-header my-2">Survey Before</p>

        <p class="title-header my-2">Are You Keen On Using This Service?</p>
        <div class="d-flex flex-wrap justify-content-center" style="gap: 1em">
          <button (click)="surveyKeen == 1 ? (surveyKeen = 0) : (surveyKeen = 1)" [class.active]="surveyKeen == 1" class="card-sub-cate">
            <span class="card-sub-cate__title">Yes</span>
          </button>
          <button (click)="surveyKeen == 2 ? (surveyKeen = 0) : (surveyKeen = 2)" [class.active]="surveyKeen == 2" class="card-sub-cate">
            <span class="card-sub-cate__title">No</span>
          </button>
        </div>
        <p class="title-header my-2">Why?</p>
        <textarea [(ngModel)]="surveyWhyKeen" placeholder="Why..." class="form-control w-75"></textarea>
      </ng-container>

      <!-- Tab 2: Price -->
      <ng-container *ngIf="activeSuggestionChangeModalTab == 2 && suggestChangeModalCurrentIndex == 2">
        <div class="d-flex flex-column w-100" style="font-size: 1rem; color: black">
          <ng-container *ngFor="let variants of productData?.foodSpecs; index as i">
            <div class="d-flex justify-content-between py-2" style="border-bottom: 1px solid #d9d2d2" *ngIf="variants.value != '0'">
              <div class="w-25 mr-2" *ngIf="variants.image">
                <img [src]="imgUrl + variants.image" class="w-100 shadow-sm" style="aspect-ratio: 1/1; border-radius: 0.25rem" />
              </div>
              <div class="d-flex flex-column align-items-start" style="width: 80%">
                <span *ngIf="variants.value">
                  {{ variants.value }}
                </span>
                <span *ngIf="variants.nKey && variants.nKey !== '0'" style="color: rgb(94, 92, 92)">{{ variants.nKey }}</span>
                <label class="t-btn mt-2 mb-0" style="color: var(--secondary); font-size: 0.75rem; display: flex; align-items: center"> <input type="checkbox" [checked]="flaggedVariants.has(variants.value)" (change)="!$event.target.checked ? flaggedVariants.delete(variants.value) : flaggedVariants.add(variants.value)" style="accent-color: var(--secondary)" /> <span style="margin-left: 0.25rem; text-decoration: underline">This Variant Doesn't Exist Any Longer</span> </label>
              </div>
              <div style="align-content: space-between; display: grid">
                <div *ngIf="variants.key && variants.key !== '0'" style="color: var(--primary); font-size: 1.25rem; font-weight: 600">${{ variants.key }}</div>
                <input type="number" placeholder="Update $" [(ngModel)]="variationPriceSuggestion[variants.value]" class="form-control form-control-sm" style="width: 6rem" />
              </div>
              <button (click)="likedVariants.has(variants.value) ? likedVariants.delete(variants.value) : likedVariants.add(variants.value)" class="t-btn ml-2" style="display: flex; align-items: end; font-size: 1.5rem; margin-bottom: 0.25rem; margin-right: 0.25rem">
                <i [class.fa-solid]="likedVariants.has(variants.value)" [class.fa-regular]="!likedVariants.has(variants.value)" class="fa-heart" style="color: var(--secondary)"></i>
              </button>
            </div>
          </ng-container>
          <div class="d-flex flex-column">
            <!-- <div class="title-header my-1">Suggest new variants <span (click)="addNewVariantSuggestion()"
                    style="width: 1.5rem; height: 1.5rem; line-height: 1.3; display: inline-flex; justify-content: center; border-radius: 0.25rem; background-color: var(--primary); color: #fff; border: 0; cursor: pointer">+</span>
                </div>
                <ng-container *ngFor="let newVariantSuggestion of newVariantSuggestions; index as i">
                  <div class="my-2" style="display: grid; grid-template-columns: 5rem 1fr 1.5rem; gap: 0.5rem">
                    @if(newVariantSuggestion.encodedPhoto){
                    <img [src]="newVariantSuggestion.encodedPhoto" class="shadow" style="width: 5rem; height: 5rem"
                      (click)="openSelectNewVariantImageOf(i)" />
                    }@else{
                    <img src="../../assets/images/uploadd2.png" class="shadow"
                      style="width: 5rem; height: 5rem; object-fit: cover" (click)="openSelectNewVariantImageOf(i)" />
                    }
                    <input type="file" class="d-none" [id]="'sugNewVariant' + i"
                      (change)="setNewVariantImageOf(i, $event)" />
                    <div style="display: grid; gap: 0.5rem">
                      <input [(ngModel)]="newVariantSuggestion.name" type="text" class="form-control"
                        placeholder="Name of The Variant" />
                      <textarea [(ngModel)]="newVariantSuggestion.description" class="form-control"
                        placeholder="Description Of The Variant" rows="7"></textarea>
                      <input [(ngModel)]="newVariantSuggestion.price" class="form-control" type="number"
                        placeholder="Price Of The Variant" />
                    </div>
                    <button class="btn btn-sm btn-outline-secondary" style="border: 1px solid #ced4da !important"
                      (click)="removeNewVariantSuggestion(i)"><i class="fa-solid fa-times"></i></button>
                  </div>
                </ng-container> -->
            <div class="d-flex flex-column">
              <p class="title-header" [class.grayed-out]="reviewPropExists(productData, 'newVariantSuggestions', 'arr')">
                Suggest new variants
                <span class="plus-btn" (click)="addNewVariantSuggestion()" [class.grayed-out]="reviewPropExists(productData, 'newVariantSuggestions', 'arr')">+</span>
              </p>
              <ng-container *ngFor="let newVariantSuggestion of newVariantSuggestions; index as i">
                <div class="d-flex my-2 justify-content-center w-100">
                  @if (newVariantSuggestion.encodedPhoto) {
                    <img [src]="newVariantSuggestion.encodedPhoto" class="shadow ml-2" style="width: 5em; height: 5em" (click)="openSelectNewVariantImageOf(i)" />
                  } @else {
                    <img src="../../assets/images/uploadd2.png" class="shadow ml-2" style="width: 5em; height: 5em" (click)="openSelectNewVariantImageOf(i)" />
                  }
                  <input type="file" class="d-none" [id]="'sugNewVariant' + i" (change)="setNewVariantImageOf(i, $event)" accept="image/*" />
                  <div class="d-flex flex-column ml-2" style="gap: 0.5em">
                    <input [(ngModel)]="newVariantSuggestion.name" type="text" class="form-control" placeholder="Name of The Variant" />
                    <textarea [(ngModel)]="newVariantSuggestion.description" class="form-control" placeholder="Description Of The Variant" rows="7"></textarea>
                    <input [(ngModel)]="newVariantSuggestion.price" class="form-control" type="number" placeholder="Price Of The Variant" />
                  </div>
                  <button class="t-btn ml-4" style="height: fit-content; color: var(--secondary); align-self: center" (click)="removeNewVariantSuggestion(i)"><i class="fa fa-x"></i></button>
                </div>

                <!-- Tab 3: Images -->
                <ng-container *ngIf="activeSuggestionChangeModalTab == 3 && suggestChangeModalCurrentIndex == 2">
                  <p class="title-header my-2">Suggest Photo Changes</p>
                  <div class="d-flex w-100 mb-4">
                    <ng-container *ngFor="let i of [1, 2, 3, 4]">
                      <span class="position-relative sugg-img mr-3" *ngIf="productData?.['food_image_' + i]">
                        <img class="suggest-change-img mr-3" [src]="imgUrl + productData?.['food_image_' + i]" />
                      </span>
                    </ng-container>
                  </div>
                  <div class="d-flex w-100 mb-2">
                    <ng-container *ngFor="let i of [0, 1, 2, 3]">
                      <span class="position-relative sugg-img mr-3">
                        <ng-container *ngIf="encodedSuggestImages[i]">
                          <img class="suggest-change-img mr-3" [src]="encodedSuggestImages[i]" />
                          <span class="delete-img"><i class="fa fa-trash" (click)="deleteSuggestImage(i)"></i></span>
                        </ng-container>
                      </span>
                    </ng-container>
                  </div>
                  <img class="suggest-change-img mr-3 shadow" src="../../assets/images/uploadd2.png" (click)="selectSuggestChangeImage(i)" />
                  <input type="file" (change)="setImageOfSuggestImages($event)" id="imgSugSelector" style="visibility: hidden; width: 0" multiple />
                </ng-container>
              </ng-container>

              <!-- <button class="btn btn-outline-secondary" (click)="addNewVariantSuggestion()">+ Add a new Variant</button> -->
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Tab 3: Images -->
      <ng-container *ngIf="activeSuggestionChangeModalTab == 3 && suggestChangeModalCurrentIndex == 2">
        <p class="title-header my-2">Suggest Photo Changes</p>
        <div class="d-flex w-100 mb-4">
          <ng-container *ngFor="let i of [1, 2, 3, 4]">
            <span class="position-relative sugg-img mr-3" *ngIf="productData?.['food_image_' + i]">
              <img class="suggest-change-img mr-3" [src]="imgUrl + productData?.['food_image_' + i]" />
            </span>
          </ng-container>
        </div>
        <div class="d-flex w-100 mb-2">
          <ng-container *ngFor="let i of [0, 1, 2, 3]">
            <span class="position-relative sugg-img mr-3">
              <ng-container *ngIf="encodedSuggestImages[i]">
                <img class="suggest-change-img mr-3" [src]="encodedSuggestImages[i]" />
                <span class="delete-img"><i class="fa fa-trash" (click)="deleteSuggestImage(i)"></i></span>
              </ng-container>
            </span>
          </ng-container>
        </div>
        <img class="suggest-change-img mr-3 shadow" src="../../assets/images/uploadd2.png" (click)="selectSuggestChangeImage(i)" />
        <input type="file" (change)="setImageOfSuggestImages($event)" id="imgSugSelector" style="visibility: hidden; width: 0" multiple accept="image/*" />
      </ng-container>

      <!-- Tab 4: Review Info -->
      <ng-container *ngIf="activeSuggestionChangeModalTab == 4 && suggestChangeModalCurrentIndex == 2">
        <div class="w-100" [class.grayed-out]="reviewPropExists(productData, 'reviewsRatingSuggestion', 'obj')">
          <div *ngTemplateOutlet="prodReviews"></div>
        </div>
      </ng-container>

      <!-- Tab 5: Description -->
      <ng-container *ngIf="activeSuggestionChangeModalTab == 5 && suggestChangeModalCurrentIndex == 2">
        <div class="d-flex flex-column w-100">
          <p class="my-2" id="reviewDescr" [class.line-break-5]="!isReviewShowingFullDescritpion && doesReviewDescriptionPassline" style="word-break: break-all">
            {{ productData?.description }}
          </p>
          <!-- <button class="t-btn" *ngIf="doesReviewDescriptionPassline"
                (click)="isReviewShowingFullDescritpion = !isReviewShowingFullDescritpion" style="color: var(--secondary);">
                Show {{  isReviewShowingFullDescritpion ? "Less" : "More" }}
              </button> -->
          <div class="w-100 d-flex justify-content-center position-relative" style="color: var(--primary)">
            <button class="scroll-arrow" (click)="isReviewShowingFullDescritpion = !isReviewShowingFullDescritpion" *ngIf="doesReviewDescriptionPassline">
              <span>See More</span>
              <i [class.down]="!isReviewShowingFullDescritpion" class="fa-solid fa-chevron-up"></i>
            </button>
          </div>
          <p class="title-header mb-1" [class.grayed-out]="reviewPropExists(productData, 'descriptionChanges', 'int')">Suggest Description</p>
          <textarea [(ngModel)]="suggestDescrChange" placeholder="Suggest changes to description" rows="4" [class.grayed-out]="reviewPropExists(productData, 'descriptionChanges', 'int')" class="form-control mb-2"></textarea>
        </div>
      </ng-container>

      <!-- Submit button -->
      <div class="w-100 d-flex justify-content-center mt-4 position-sticky">
        <button class="my-button-3" (click)="submitReview()"><i class="fa fa-check"></i> Submit</button>
      </div>
    </div>
  </div>
</div>
